<div class="background"></div>

<router-outlet></router-outlet>

<span class="btn btn-primary btn-audio" (click)="toggleMusic()">Toggle Music</span>
